<template>
	<div class="spotUseBox">
		<div class="column">
			<div class="columnText2 aligned">
				预约方式
			</div>
			<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.appointment == 1 ? '无需预约' :
				datas.otherStockData.appointment == 2 ? '需预约' : '未填写' }}</div>
		</div>
		<div class="column">
			<div class="columnText2 aligned">
				入园时间
			</div>
			<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.appointmentMethod
				? datas.otherStockData.appointmentMethod : '未填写' }}</div>
		</div>
		<div class="column">
			<div class="columnText2 aligned">
				取票方式
			</div>
			<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.ticketMethod == 1 ? '无需取票'
				:
				datas.otherStockData.ticketMethod == 2 ? '需取票' : '未填写' }}</div>
		</div>
		<div v-if="datas.otherStockData.ticketMethod == 2">
			<div class="column">
				<div class="columnText2 aligned">
					取票地址
				</div>
				<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.address
					? datas.otherStockData.address : '未填写' }}</div>
			</div>
			<div class="column">
				<div class="columnText2 aligned">
					取票时间段
				</div>
				<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.ticketTime
					? datas.otherStockData.ticketTime : '未填写' }}</div>
			</div>
			<div class="column">
				<div class="columnText2 aligned">
					取票联系人信息
				</div>
				<div class="columnText3" style="flex: 1;text-align: center;">{{ datas.otherStockData.ticketContactInfo
					? datas.otherStockData.ticketContactInfo : '未填写' }}</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText4 aligned">
				入园时间段
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.otherStockData.joinTime" class="columnText3" placeholder-class="placeholder"
				style="flex: 1;" placeholder="请在此处填写可入园时间段，如有季节区分，请注明" type="text"></el-input>
		</div>
		<div class="column">
			<div class="columnText4 aligned">
				使用说明文字描述
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.useExplain" class="columnText3" placeholder-class="placeholder"
				style="flex: 1;" placeholder="请输入使用说明文字描述" type="text"></el-input>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			init: this.datas,
			keys: '',
			makeList: [
				{
					name: '无需预约',
					code: 1
				},
				{
					name: '需预约',
					code: 2
				}

			],
			takeList: [
				{
					name: '无需取票',
					code: 1
				},
				{
					name: '需取票',
					code: 2
				}
			],
		}
	},
	mounted() {
		console.log(this.datas, '看看撒豆啊激动');
	},
	methods: {
		//门票是否需要预约
		pickerChange1(val, type) {
			const map = {
				'预约': () => this.$set(this.datas.otherStockData, 'appointment', this.makeList[val.detail.value].code),
				'取票': () => this.$set(this.datas.otherStockData, 'ticketMethod', this.takeList[val.detail.value].code)
			}
			if (map[type]) {
				map[type]()
			}
		},
		//打开取票弹窗
		handlerOpenTakePopup(key) {
			this.keys = key
			this.$refs.takePopup.handleShowShare()
		},
		//打开预约弹框
		handlerOpenMakePopup(key) {
			this.keys = key
			this.$refs.makePopup.handleShowShare()
		},
		saveDescription() {
			let text = this.$refs.newTextarea.reason
			this.$set(this.datas.otherStockData, this.keys, text)
			uni.showToast({
				title: '保存成功',
				icon: 'none',
				duration: 1000
			});
		},
		saveDescription1() {
			console.log(this.$refs.address.reason, '来看坎坎坷坷');
			this.$set(this.datas.otherStockData, 'address', this.$refs.address.reason)
			this.$set(this.datas.otherStockData, 'ticketTime', this.$refs.ticketTime.reason)
			this.$set(this.datas.otherStockData, 'ticketContactInfo', this.$refs.ticketContactInfo.reason)
			uni.showToast({
				title: '保存成功',
				icon: 'none',
				duration: 1000
			});
		}
	},
	watch: {
		datas: {
			handler(n, o) {
				this.$emit('updateDatas', n)
				console.log('监听触发拉888');
			},
			deep: true,

		}
	}
}
</script>


<style lang="scss" scoped>
.spotUseBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.aligned {
		width: 1.2rem;
		text-align: left !important;
	}

	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 70rpx;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			text-align: center;
		}

		.columnText3 {
			color: #000000;
			text-align: center;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			text-align: center;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}
</style>
